export const parseParams = (config, {
    categoryID: categoryId,
    geoID: locationId
}) => {
    const { SEO = {}} = config || {};

    const { fetchDefaultPopularSearches = false } = SEO;

    return fetchDefaultPopularSearches ? {} : { categoryId, locationId };
};

export const parseQuery = ({ filter }) => ({ filter });
